<template>
  <div class="projects-empty">
    <img
      src="@/assets/img/no-projects.svg"
      alt="empty projects"
    >
    <div class="subtitle-2 text-center mt-6">
      {{ header }}
    </div>
    <div
      class="caption text-center mt-3"
      v-html="text"
    />
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      default: 'Nie znaleziono żadnych projektów',
    },
    text: {
      type: String,
      default: `Nie znaleziono żadnych projektów. <br>
      Zmień w filtrach sposób wyszukiwania.`,
    },
  },
};
</script>

<style lang="scss" scoped>
.projects-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
